(function () {
  function money(cents) {
    var value = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(value);
    }

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD"
    }).format(value / 100);
  }

  function getJson(root, selector) {
    var script = root.querySelector(selector);
    if (!script) return [];

    try {
      return JSON.parse(script.textContent || "[]");
    } catch (error) {
      return [];
    }
  }

  function findVariantById(variants, id) {
    return variants.find(function (variant) {
      return String(variant.id) === String(id);
    });
  }

  function normalizeOptionValue(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function buildOptionSet(root, currentVariant) {
    var base = currentVariant && currentVariant.options ? currentVariant.options.slice() : [];
    var groups = Array.prototype.slice.call(root.querySelectorAll("[data-sms-visual-option-group]"));

    groups.forEach(function (group) {
      var position = Number(group.getAttribute("data-option-position")) - 1;
      var checked = group.querySelector("[data-sms-visual-option]:checked");
      if (checked && position >= 0) base[position] = checked.value;
    });

    return base;
  }

  function optionMatch(variant, options) {
    if (!variant || !variant.options || variant.options.length !== options.length) return false;

    return options.every(function (value, index) {
      return normalizeOptionValue(variant.options[index]) === normalizeOptionValue(value);
    });
  }

  function findVariant(variants, options) {
    return variants.find(function (variant) {
      return optionMatch(variant, options);
    });
  }

  function addDays(date, days) {
    var next = new Date(date.getTime());
    next.setDate(next.getDate() + days);
    return next;
  }

  function formatShortDate(date) {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric"
    });
  }

  function formatRange(start, end) {
    if (!start || !end) return "";
    return formatShortDate(start) + " - " + formatShortDate(end);
  }

  function setTimeline(root) {
    var timeline = root.querySelector("[data-sms-visual-timeline]");
    if (!timeline) return;

    var now = new Date();
    var orderReadyStart = addDays(now, 4);
    var orderReadyEnd = addDays(now, 5);
    var deliveredStart = addDays(now, 5);
    var deliveredEnd = addDays(now, 8);
    var cutoff = new Date(now.getTime());
    cutoff.setHours(23, 59, 59, 999);

    var orderDate = timeline.querySelector("[data-sms-timeline-order-date]");
    var readyDate = timeline.querySelector("[data-sms-timeline-ready-date]");
    var deliveredDate = timeline.querySelector("[data-sms-timeline-delivered-date]");
    var countdown = timeline.querySelector("[data-sms-timeline-countdown]");
    var windowLabel = timeline.querySelector("[data-sms-timeline-window]");

    if (orderDate) orderDate.textContent = formatShortDate(now);
    if (readyDate) readyDate.textContent = formatRange(orderReadyStart, orderReadyEnd);
    if (deliveredDate) deliveredDate.textContent = formatRange(deliveredStart, deliveredEnd);
    if (windowLabel) windowLabel.textContent = formatRange(deliveredStart, deliveredEnd);

    function tick() {
      if (!countdown) return;

      var remaining = Math.max(0, cutoff.getTime() - Date.now());
      var seconds = Math.floor(remaining / 1000);
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      var secs = seconds % 60;
      countdown.textContent = hours + " hours " + minutes + " minutes " + secs + " seconds";
    }

    tick();
    if (!timeline.dataset.smsTimelineTimer) {
      timeline.dataset.smsTimelineTimer = "true";
      setInterval(tick, 1000);
    }
  }

  function syncOptionInputs(root, variant) {
    if (!variant || !variant.options) return;

    root.querySelectorAll("[data-sms-visual-option-group]").forEach(function (group) {
      var position = Number(group.getAttribute("data-option-position")) - 1;
      if (position < 0) return;

      group.querySelectorAll("[data-sms-visual-option]").forEach(function (input) {
        input.checked = String(input.value) === String(variant.options[position]);
      });
    });
  }

  function getNativeVariantPicker(root) {
    return root.querySelector("variant-selects");
  }

  function getNativeOptionGroups(picker) {
    if (!picker) return [];

    return Array.prototype.slice.call(picker.querySelectorAll("fieldset, .product-form__input--dropdown")).filter(function (group) {
      return group.querySelector('input[type="radio"], select');
    });
  }

  function getNativeOptionPosition(control, fallbackIndex) {
    if (!control) return fallbackIndex;

    var name = control.getAttribute("name") || "";
    var namePosition = name.match(/-(\d+)$/);
    if (namePosition) return Number(namePosition[1]) - 1;

    var id = control.getAttribute("id") || "";
    var idPosition = id.match(/Option-.+-(\d+)$/);
    if (idPosition) return Number(idPosition[1]);

    return fallbackIndex;
  }

  function readNativeOptions(root, currentVariant) {
    var picker = getNativeVariantPicker(root);
    var groups = getNativeOptionGroups(picker);
    var options = currentVariant && currentVariant.options ? currentVariant.options.slice() : [];

    groups.forEach(function (group, index) {
      var checked = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector("select");
      var control = checked || select;
      var value = checked ? checked.value : (select ? select.value : "");
      var position = getNativeOptionPosition(control, index);

      if (value && position >= 0) {
        options[position] = value;
      }
    });

    return options;
  }

  function findNativeVariant(root, variants, currentVariant) {
    var options = readNativeOptions(root, currentVariant);
    var matched = options.length ? findVariant(variants, options) : null;
    if (matched) return matched;

    var checkedWithVariantId = root.querySelector('variant-selects input[type="radio"]:checked[data-varid]');
    if (checkedWithVariantId && checkedWithVariantId.getAttribute("data-varid")) {
      matched = findVariantById(variants, checkedWithVariantId.getAttribute("data-varid"));
      if (matched) return matched;
    }

    var picker = getNativeVariantPicker(root);
    var selectedVariant = picker && picker.querySelector("[data-selected-variant]");
    if (!selectedVariant) return null;

    try {
      var parsed = JSON.parse(selectedVariant.textContent || "{}");
      return parsed && parsed.id ? findVariantById(variants, parsed.id) : null;
    } catch (error) {
      return null;
    }
  }

  function getNativePickerControl(root, event) {
    var target = event && event.target;
    if (!target || !target.closest) return null;

    var control = target.closest('input[type="radio"], select, label[for]');
    if (!control || !root.contains(control)) return null;

    if (control.matches && control.matches("label[for]")) {
      var input = document.getElementById(control.getAttribute("for") || "");
      return input && root.contains(input) ? input : null;
    }

    return control;
  }

  function findNativeVariantFromEvent(root, variants, event, currentVariant) {
    var control = getNativePickerControl(root, event);
    if (!control) return null;

    if (control.getAttribute && control.getAttribute("data-varid")) {
      var byId = findVariantById(variants, control.getAttribute("data-varid"));
      if (byId) return byId;
    }

    var groups = getNativeOptionGroups(getNativeVariantPicker(root));
    var groupIndex = groups.findIndex(function (group) {
      return group.contains(control);
    });
    var position = getNativeOptionPosition(control, groupIndex >= 0 ? groupIndex : 0);
    var value = control.value;

    if (!value || position < 0) return null;

    var options = currentVariant && currentVariant.options ? currentVariant.options.slice() : [];
    options[position] = value;

    return findVariant(variants, options);
  }

  function syncNativeOptionInputs(root, variant) {
    if (!variant || !variant.options) return;

    getNativeOptionGroups(getNativeVariantPicker(root)).forEach(function (group, index) {
      var value = variant.options[index];
      if (typeof value === "undefined") return;

      group.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.checked = String(input.value) === String(value);
      });

      var select = group.querySelector("select");
      if (select) select.value = value;

      var selectedLabel = group.querySelector("[data-selected-value]");
      if (selectedLabel) selectedLabel.textContent = value;
    });
  }

  function setNativeProductFormVariant(root, variant) {
    var productForms = root.querySelectorAll('form[data-type="add-to-cart-form"]');
    var isAvailable = Boolean(variant && variant.available);

    productForms.forEach(function (form) {
      form.querySelectorAll('input[name="id"], .product-variant-id').forEach(function (input) {
        if (variant && variant.id) {
          input.value = String(variant.id);
          input.setAttribute("value", String(variant.id));
        }
        input.disabled = !isAvailable;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        if (variant && variant.id) {
          input.value = String(variant.id);
          input.setAttribute("value", String(variant.id));
        }
      });

      form.querySelectorAll('button[name="add"]').forEach(function (button) {
        button.disabled = !isAvailable;
        var label = button.querySelector("span");
        if (label) label.textContent = isAvailable ? "Add to cart" : "Sold out";
      });
    });
  }

  function mediaMatches(item, mediaId, imageId) {
    var itemMediaId = item.getAttribute("data-media-id");
    var itemImageId = item.getAttribute("data-image-id");

    return Boolean(
      (mediaId && itemMediaId === String(mediaId)) ||
      (imageId && itemImageId === String(imageId))
    );
  }

  function updateMedia(root, mediaId, imageId) {
    var mediaItems = root.querySelectorAll("[data-sms-visual-media]");
    var thumbs = root.querySelectorAll("[data-sms-visual-thumb]");
    var matched = false;

    if (mediaId || imageId) {
      mediaItems.forEach(function (item) {
        var isMatch = mediaMatches(item, mediaId, imageId);
        item.hidden = !isMatch;
        item.classList.toggle("is-active", isMatch);
        if (isMatch) matched = true;
      });

      thumbs.forEach(function (thumb) {
        thumb.classList.toggle("is-active", mediaMatches(thumb, mediaId, imageId));
      });
    }

    if (!matched && mediaItems[0]) {
      mediaItems.forEach(function (item, index) {
        item.hidden = index !== 0;
        item.classList.toggle("is-active", index === 0);
      });
      thumbs.forEach(function (thumb, index) {
        thumb.classList.toggle("is-active", index === 0);
      });
    }
  }

  function updateOptionAvailability(root, variants, currentVariant) {
    var current = buildOptionSet(root, currentVariant);

    root.querySelectorAll("[data-sms-visual-option-group]").forEach(function (group) {
      var position = Number(group.getAttribute("data-option-position")) - 1;

      group.querySelectorAll("[data-sms-visual-option]").forEach(function (input) {
        var trial = current.slice();
        trial[position] = input.value;
        var variant = findVariant(variants, trial);
        var label = input.closest(".sms-visual-option-pill");

        if (label) {
          label.classList.toggle("is-unavailable", !variant || variant.available === false);
        }
      });
    });
  }

  function isBackorderVariant(root, variant) {
    if (!variant) return false;

    var backorders = root && root.smsVisualBackorders ? root.smsVisualBackorders : {};
    if (backorders && backorders[String(variant.id)] === true) return true;

    var quantityKnown = typeof variant.inventory_quantity !== "undefined" && variant.inventory_quantity !== null;
    return String(variant.inventory_policy || "") === "continue" && quantityKnown && Number(variant.inventory_quantity) <= 0;
  }

  function getDeliveryCopy(delivery, key, fallback) {
    if (!delivery) return fallback;
    return delivery.getAttribute(key) || fallback;
  }

  function setDelivery(root, variant) {
    var delivery = root.querySelector("[data-sms-visual-delivery-estimate]");
    if (!delivery) return;

    var title = delivery.querySelector("[data-sms-visual-delivery-title]");
    var copy = delivery.querySelector("[data-sms-visual-delivery-copy]");
    var expected = getDeliveryCopy(delivery, "data-expected-copy", "");
    var ready = getDeliveryCopy(delivery, "data-ready-copy", "In stock, ready to ship.");
    var backorder = getDeliveryCopy(delivery, "data-backorder-copy", "Backorder available. Shipping timeline estimates may be longer than expected.");
    var unavailable = getDeliveryCopy(delivery, "data-unavailable-copy", "Currently unavailable. Contact us for lead time.");
    var nextCopy = getDeliveryCopy(delivery, "data-default-copy", "Ships in 1-2 business days.");

    if (variant && isBackorderVariant(root, variant)) {
      nextCopy = expected || backorder;
    } else if (variant && variant.available) {
      nextCopy = ready;
    } else if (expected) {
      nextCopy = expected;
    } else if (variant) {
      nextCopy = unavailable;
    }

    if (title) title.textContent = expected && variant && !variant.available ? "Expected inventory" : "Delivery estimate";
    if (copy) copy.textContent = nextCopy;
  }

  function setWishlist(root, variant) {
    var wishlist = root.querySelector("[data-sms-visual-wishlist]");
    if (!wishlist || !variant) return;

    wishlist.setAttribute("data-variant-id", variant.id);
    wishlist.setAttribute("data-product-url", window.location.origin + window.location.pathname + "?variant=" + variant.id);
  }

  function setSku(root, variant) {
    var skuChip = root.querySelector("[data-sms-visual-sku]");
    var skuValue = root.querySelector("[data-sms-visual-sku-value]");
    if (!skuChip || !skuValue) return;

    var sku = variant && variant.sku ? String(variant.sku).trim() : "";
    skuValue.textContent = sku;
    skuChip.classList.toggle("is-hidden", !sku);
  }

  function setMetrics(root, variant) {
    var metricData = root.smsVisualMetrics || {};
    var defaults = metricData.default || {};
    var variants = metricData.variants || {};
    var current = variant && variants[String(variant.id)] ? variants[String(variant.id)] : defaults;

    ["cooling", "heating", "sound", "efficiency"].forEach(function (key) {
      var target = root.querySelector('[data-sms-visual-metric-value="' + key + '"]');
      if (!target) return;

      target.textContent = current && current[key] ? current[key] : defaults[key] || "See specs";
    });
  }

  function getPricing(root, variant) {
    var pricing = root.smsVisualPricing || {};
    var variants = pricing.variants || {};
    var mapped = variant && variants[String(variant.id)] ? variants[String(variant.id)] : null;

    if (mapped) {
      var mappedPrice = Number(mapped.price || 0);
      var mappedCompare = mapped.compare_at_price ? Number(mapped.compare_at_price) : 0;
      var variantPrice = Number((variant && variant.price) || 0);
      var variantCompare = Number((variant && variant.compare_at_price) || 0);

      if (variantPrice > 0 && (!mappedPrice || variantPrice < mappedPrice)) {
        var bestCompare = variantCompare > variantPrice ? variantCompare : mappedCompare;
        var bestSavings = bestCompare > variantPrice ? bestCompare - variantPrice : 0;

        return {
          price: variantPrice,
          compare_at_price: bestSavings ? bestCompare : 0,
          savings: bestSavings,
          savings_percent: bestSavings ? Math.round((bestSavings / bestCompare) * 100) : 0,
          finance: Math.round(variantPrice / 12)
        };
      }

      return {
        price: mappedPrice,
        compare_at_price: mappedCompare,
        savings: Number(mapped.savings || 0),
        savings_percent: Number(mapped.savings_percent || 0),
        finance: Number(mapped.finance || 0)
      };
    }

    var price = Number((variant && variant.price) || 0);
    var compare = Number((variant && variant.compare_at_price) || 0);
    var hasSavings = compare > price;
    var savings = hasSavings ? compare - price : 0;

    return {
      price: price,
      compare_at_price: hasSavings ? compare : 0,
      savings: savings,
      savings_percent: hasSavings ? Math.round((savings / compare) * 100) : 0,
      finance: Math.round(price / 12)
    };
  }

  function setStock(root, stock, variant) {
    if (!stock) return;

    var isBackorder = !!(variant && isBackorderVariant(root, variant));
    stock.classList.toggle("sms-visual-stock--backorder", isBackorder);

    if (isBackorder) {
      var title = document.createElement("strong");
      title.textContent = root.getAttribute("data-backorder-notice-title") || "This product is out of stock and on backorder.";
      var copy = document.createElement("span");
      copy.textContent = root.getAttribute("data-backorder-notice-body") || "If you purchase, you acknowledge that shipping timeline estimates may be longer than expected.";
      stock.replaceChildren(title, document.createTextNode(" "), copy);
    } else if (variant && variant.available) {
      stock.innerHTML = '<span class="sms-visual-stock__dot"></span><strong>In Stock</strong><span>In stock, ready to ship</span>';
    } else {
      stock.innerHTML = '<span class="sms-visual-stock__dot sms-visual-stock__dot--out"></span><strong>Currently unavailable</strong><span>Contact us for lead time</span>';
    }
  }

  function setPickup(root, variant) {
    var pickup = root.querySelector("pickup-availability");
    if (!pickup || !variant) return;

    pickup.setAttribute("data-variant-id", variant.id);
    if (variant.available) {
      pickup.setAttribute("available", "");
    } else {
      pickup.removeAttribute("available");
    }

    if (typeof pickup.fetchAvailability === "function") {
      pickup.fetchAvailability(variant.id);
    }
  }

  function scheduleVariantSideEffects(root, variant) {
    if (!variant) return;

    if (root.smsVisualVariantSideEffectsTimer) {
      window.clearTimeout(root.smsVisualVariantSideEffectsTimer);
    }

    root.smsVisualVariantSideEffectsTimer = window.setTimeout(function () {
      root.smsVisualVariantSideEffectsTimer = null;

      if (
        !root.smsVisualCurrentVariant ||
        String(root.smsVisualCurrentVariant.id) !== String(variant.id)
      ) {
        return;
      }

      setPickup(root, variant);

      if (typeof root.smsVisualUpdateRebates === "function") {
        root.smsVisualUpdateRebates(variant.sku || "");
      }
    }, 120);
  }

  function updateVariant(root, variant, variants) {
    var idInput = root.querySelector("[data-sms-visual-variant-id]");
    var installmentInput = root.querySelector("[data-sms-visual-installment-variant-id]");
    var deliveryEstimate = root.querySelector("[data-sms-visual-delivery-estimate]");
    var prices = root.querySelectorAll("[data-sms-visual-price]");
    var finance = root.querySelector("[data-sms-visual-finance]");
    var compares = root.querySelectorAll("[data-sms-visual-compare]");
    var saves = root.querySelectorAll("[data-sms-visual-save]");
    var stock = root.querySelector("[data-sms-visual-stock]");
    var submit = root.querySelector("[data-sms-visual-submit]");
    var submitText = root.querySelector("[data-sms-visual-submit-text]");
    var pricing = getPricing(root, variant);

    if (!variant) {
      if (submit) submit.disabled = true;
      if (submitText) submitText.textContent = "Unavailable";
      setNativeProductFormVariant(root, null);
      root.smsVisualVariantReady = "true";
      setStock(root, stock, null);
      setDelivery(root, null);
      setTimeline(root);
      setMetrics(root, null);
      updateOptionAvailability(root, variants, findVariantById(variants, idInput && idInput.value) || variants[0]);
      return null;
    }

    if (
      root.smsVisualVariantReady === "true" &&
      root.smsVisualCurrentVariant &&
      String(root.smsVisualCurrentVariant.id) === String(variant.id)
    ) {
      if (idInput) {
        idInput.value = String(variant.id);
        idInput.setAttribute("value", String(variant.id));
      }
      if (installmentInput) {
        installmentInput.value = String(variant.id);
        installmentInput.setAttribute("value", String(variant.id));
      }
      setNativeProductFormVariant(root, variant);
      return variant;
    }

    root.smsVisualCurrentVariant = variant;

    if (idInput) idInput.value = variant.id;
    if (deliveryEstimate) deliveryEstimate.setAttribute("data-variant-id", variant.id);
    if (installmentInput) {
      installmentInput.value = variant.id;
      installmentInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
    syncOptionInputs(root, variant);
    syncNativeOptionInputs(root, variant);
    setNativeProductFormVariant(root, variant);
    if (idInput) {
      idInput.value = String(variant.id);
      idInput.setAttribute("value", String(variant.id));
    }
    if (installmentInput) {
      installmentInput.value = String(variant.id);
      installmentInput.setAttribute("value", String(variant.id));
    }

    prices.forEach(function (price) {
      price.setAttribute("data-money-cents", pricing.price);
      price.textContent = money(pricing.price);
    });

    if (finance) {
      finance.textContent = money(pricing.finance);
    }

    var compareValue = pricing.compare_at_price;
    var hasSavings = compareValue && pricing.savings > 0;
    var savings = pricing.savings;
    var percent = pricing.savings_percent || 0;

    compares.forEach(function (compare) {
      compare.classList.toggle("is-hidden", !hasSavings);
      compare.textContent = hasSavings ? money(compareValue) : "";
    });

    saves.forEach(function (save) {
      save.classList.toggle("is-hidden", !hasSavings);
      save.textContent = hasSavings ? "Save " + money(savings) + " (" + percent + "%)" : "";
    });

    setStock(root, stock, variant);
    setDelivery(root, variant);
    setTimeline(root);
    setWishlist(root, variant);
    setSku(root, variant);
    setMetrics(root, variant);
    updateQuantityRules(root, variant);

    if (submit) submit.disabled = !variant.available;
    if (submitText) submitText.textContent = variant.available ? "Add to Cart" : "Sold Out";

    updateMedia(
      root,
      variant.featured_media && variant.featured_media.id,
      variant.featured_image && variant.featured_image.id
    );

    updateOptionAvailability(root, variants, variant);

    scheduleVariantSideEffects(root, variant);

    root.smsVisualVariantReady = "true";

    var eventDetail = { variant: variant };

    root.smsVisualDispatchingVariant = true;

    root.dispatchEvent(new CustomEvent("sms:visual-variant-change", {
      bubbles: true,
      detail: eventDetail
    }));
    root.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: eventDetail }));
    root.dispatchEvent(new CustomEvent("sms:plex-estimate:update", { bubbles: true, detail: eventDetail }));
    document.dispatchEvent(new CustomEvent("sms:visual-variant-change", { detail: eventDetail }));
    document.dispatchEvent(new CustomEvent("variant:change", { detail: eventDetail }));
    document.dispatchEvent(new CustomEvent("sms:plex-estimate:update", { detail: eventDetail }));

    root.smsVisualDispatchingVariant = false;

    if (window.history && window.URL && window.location.search.indexOf("variant=") !== -1) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());
    }

    return variant;
  }

  function openCartFallback() {
    var cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.open === "function") {
      cartDrawer.open();
      return;
    }

    var drawerTrigger = document.querySelector("[data-cart-drawer-open], .js-drawer-open-cart");
    if (drawerTrigger) {
      drawerTrigger.click();
      return;
    }

    window.location.href = "/cart";
  }

  function getQuantityInput(form, root) {
    var input = form && form.elements ? form.elements.quantity : null;

    if (input && typeof input.length === "number" && !input.tagName) {
      input = input[0];
    }

    return input || (form && form.querySelector('[name="quantity"]')) || root.querySelector("[data-sms-visual-quantity-input]");
  }

  function clampQuantityInput(input) {
    if (!input) return 1;

    var min = Math.max(1, Number(input.getAttribute("min") || 1));
    var step = Math.max(1, Number(input.getAttribute("step") || 1));
    var maxAttr = input.getAttribute("max");
    var max = maxAttr !== null && maxAttr !== "" ? Number(maxAttr) : null;
    var value = Math.round(Number(input.value || min));

    if (Number.isNaN(value)) value = min;
    value = Math.max(min, value);
    if (max !== null && !Number.isNaN(max)) value = Math.min(max, value);

    var offset = (value - min) % step;
    if (offset !== 0) value -= offset;

    input.value = String(value);
    return value;
  }

  function updateQuantityRules(root, variant) {
    var input = root.querySelector("[data-sms-visual-quantity-input]");
    if (!input || !variant) return;

    var rule = variant.quantity_rule || {};
    var min = Math.max(1, Number(rule.min || input.getAttribute("min") || 1));
    var step = Math.max(1, Number(rule.increment || input.getAttribute("step") || 1));
    var max = rule.max;

    input.setAttribute("min", String(min));
    input.setAttribute("step", String(step));

    if (max) {
      input.setAttribute("max", String(max));
    } else {
      input.removeAttribute("max");
    }

    clampQuantityInput(input);
  }

  function bindQuantity(root) {
    root.querySelectorAll("[data-sms-visual-quantity]").forEach(function (quantity) {
      if (quantity.dataset.smsQuantityInit === "true") return;
      quantity.dataset.smsQuantityInit = "true";

      var input = quantity.querySelector("[data-sms-visual-quantity-input]");
      if (!input) return;

      quantity.addEventListener("click", function (event) {
        var button = event.target.closest("[data-sms-quantity-step]");
        if (!button || !quantity.contains(button)) return;

        var direction = Number(button.getAttribute("data-sms-quantity-step") || 0);
        var step = Math.max(1, Number(input.getAttribute("step") || 1));
        var current = clampQuantityInput(input);

        input.value = String(current + direction * step);
        clampQuantityInput(input);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });

      input.addEventListener("change", function () {
        clampQuantityInput(input);
      });
    });
  }

  function bindForm(root) {
    var form = root.querySelector('form[data-type="add-to-cart-form"]') || root.querySelector(".sms-visual-buybox__form");
    if (!form) return;

    form.addEventListener("submit", function (event) {
      var selectedAddons = Array.prototype.slice.call(root.querySelectorAll("[data-sms-visual-addon-variant]:checked"));
      if (!selectedAddons.length || !window.fetch) return;

      event.preventDefault();

      var variantInput = root.querySelector("[data-sms-visual-variant-id]");
      var submit = root.querySelector("[data-sms-visual-submit]");
      var submitText = root.querySelector("[data-sms-visual-submit-text]");
      var quantityInput = getQuantityInput(form, root);
      var quantity = quantityInput ? Math.max(1, Number(quantityInput.value || 1)) : 1;
      var items = [];

      if (variantInput && variantInput.value) {
        items.push({ id: Number(variantInput.value), quantity: quantity });
      }

      selectedAddons.forEach(function (addon) {
        if (addon.value) items.push({ id: Number(addon.value), quantity: 1 });
      });

      if (!items.length) return;

      if (submit) submit.disabled = true;
      if (submitText) submitText.textContent = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Unable to add items");
          return response.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          document.dispatchEvent(new CustomEvent("cart:change", { bubbles: true }));
          openCartFallback();
        })
        .catch(function () {
          if (submitText) submitText.textContent = "Try Again";
        })
        .finally(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  function bindZoom(root) {
    root.querySelectorAll("[data-sms-visual-media]").forEach(function (media) {
      media.addEventListener("click", function () {
        var img = media.querySelector("img");
        if (!img || !img.src) return;
        window.open(img.src, "_blank", "noopener");
      });
    });
  }

  function bindMoreMedia(root) {
    var button = root.querySelector("[data-sms-visual-more]");
    if (!button) return;

    var extraThumbs = Array.prototype.slice.call(root.querySelectorAll("[data-sms-visual-extra-thumb]"));
    if (!extraThumbs.length) {
      button.hidden = true;
      return;
    }

    button.addEventListener("click", function () {
      extraThumbs.forEach(function (thumb) {
        thumb.hidden = false;
        thumb.removeAttribute("hidden");
        thumb.style.display = "";
      });

      button.setAttribute("aria-expanded", "true");
      button.hidden = true;
    });
  }

  function bindAccessoryVisibility(root) {
    var panel = root.querySelector("[data-sms-visual-addons-panel]");
    if (!panel) return;

    var list = panel.querySelector("[data-sms-acc-list], .sms-acc-recs__list, #sms-acc-recs-list");
    if (!list) {
      panel.hidden = true;
      return;
    }

    function update() {
      var hasRealRows = Boolean(list.querySelector(".sms-acc-row:not(.sms-acc-ghost)"));

      panel.hidden = !hasRealRows;
      panel.classList.toggle("is-ready", hasRealRows);
      root.classList.toggle("has-visual-accessories", hasRealRows);
    }

    update();

    if (window.MutationObserver) {
      new MutationObserver(update).observe(list, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    setTimeout(update, 400);
    setTimeout(update, 1600);
    setTimeout(update, 3200);
  }

  function bindWishlist(root) {
    var wishlist = root.querySelector("[data-sms-visual-wishlist]");
    if (!wishlist) return;

    wishlist.addEventListener("click", function () {
      window.setTimeout(function () {
        if (wishlist.classList.contains("swym-added")) {
          wishlist.classList.add("is-active");
        } else if (!window.SwymCallbacks && !window._swat) {
          wishlist.classList.toggle("is-active");
        }

        wishlist.setAttribute("aria-pressed", wishlist.classList.contains("is-active") ? "true" : "false");
      }, 0);
    });
  }

  function normalizeText(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9 ]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function isCooperHunter(value) {
    return /co+per(?:\s+and)?\s+hunter/.test(normalizeText(value));
  }

  function isAciq(value) {
    return normalizeText(value).replace(/\s+/g, "").indexOf("aciq") !== -1;
  }

  function isMrCool(value) {
    return normalizeText(value).replace(/\s+/g, "").indexOf("mrcool") !== -1;
  }

  function collectContextValues(context) {
    var values = [context && context.title, context && context.vendor, context && context.type];
    var tags = context && context.tags;
    var brandMeta = context && context.brandMeta;

    if (Array.isArray(tags)) {
      tags.forEach(function (tag) { values.push(tag); });
    }

    if (Array.isArray(brandMeta)) {
      brandMeta.forEach(function (brand) { values.push(brand); });
    } else {
      values.push(brandMeta);
    }

    return values;
  }

  function getRebateProvider(context) {
    var values = collectContextValues(context);

    if (values.some(isCooperHunter)) {
      return {
        key: "cooper_hunter",
        baseUrl: "https://cooper_and_hunter.ecorebates.com/api/search/cooper_and_hunter/productRebateDetails.json",
        skuParam: "q",
        extraParams: {
          pageIdx: "0",
          pageSize: "100"
        }
      };
    }

    if (values.some(isMrCool)) {
      return {
        key: "mrcool",
        baseUrl: "https://mrcool.ecorebates.com/api/search/mrcool/productRebateDetails.json",
        skuParam: "q",
        extraParams: {
          pageIdx: "0",
          pageSize: "20"
        }
      };
    }

    if (values.some(isAciq)) {
      return {
        key: "aciq",
        baseUrl: "https://hvacdirect.ecorebates.com/api/search/hvacdirect/productRebateDetails.json",
        skuParam: "skus",
        extraParams: {}
      };
    }

    return {
      key: "hvacdirect",
      baseUrl: "https://hvacdirect.ecorebates.com/api/search/hvacdirect/productRebateDetails.json",
      skuParam: "skus",
      extraParams: {}
    };
  }

  function extractSkus(rawText) {
    var cleaned = String(rawText || "")
      .replace(/`/g, " ")
      .toUpperCase()
      .replace(/\s*-\s*/g, "-")
      .replace(/\b\d+\s*X\s*/g, " ")
      .replace(/\s*X\s*\d+\b/g, " ")
      .replace(/\+\s*/g, " ")
      .replace(/,\s*/g, " ");
    var broadMatches = cleaned.match(/[A-Z0-9-]{5,}/g) || [];
    var legacyMatches = cleaned.match(/[A-Z0-9]+(?:-[A-Z0-9]+)+|[A-Z]{2,}[A-Z0-9-]*\d+[A-Z0-9-]*/g) || [];
    var seen = {};
    var results = [];

    broadMatches.concat(legacyMatches).forEach(function (match) {
      var token = String(match || "").replace(/[^A-Z0-9-]/g, "").trim();
      if (!token || token === "SKU" || !/[A-Z]/.test(token) || !/\d/.test(token) || seen[token]) return;
      seen[token] = true;
      results.push(token);
    });

    return results;
  }

  function normalizeSku(value) {
    return String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  }

  function detailMatchesRequestedSku(detail, requestedSku, provider) {
    var product = detail && detail.product ? detail.product : {};
    var target = normalizeSku(requestedSku);
    var providerKey = provider && provider.key ? provider.key : "";
    var candidates = providerKey === "cooper_hunter"
      ? [product.displaySku, product.mfrSKU, product.siteSKU, product.sku, product.mpn]
      : [product.displaySku, product.mfrSKU, product.siteSKU, product.sku, product.altSiteSKU, product.mpn, product.itemNumber];

    if (!target) return false;

    return candidates.some(function (candidate) {
      return normalizeSku(candidate) === target;
    });
  }

  function formatUSD(amount) {
    var value = Number(amount || 0);
    if (!isFinite(value)) value = 0;

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0
    }).format(value);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function jsonpRequest(url, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var callbackName = "smsVisualRebateCb_" + Date.now() + "_" + Math.floor(Math.random() * 100000);
      var script = document.createElement("script");
      var timeoutHandle = null;

      function cleanup() {
        if (timeoutHandle) clearTimeout(timeoutHandle);
        if (script.parentNode) script.parentNode.removeChild(script);
        try {
          delete window[callbackName];
        } catch (error) {
          window[callbackName] = undefined;
        }
      }

      window[callbackName] = function (payload) {
        cleanup();
        resolve(payload);
      };

      script.onerror = function () {
        cleanup();
        reject(new Error("Failed to load rebate data."));
      };

      timeoutHandle = setTimeout(function () {
        cleanup();
        reject(new Error("Rebate lookup timed out."));
      }, timeoutMs || 15000);

      script.src = url + (url.indexOf("?") >= 0 ? "&" : "?") + "jsoncallback=" + callbackName;
      document.head.appendChild(script);
    });
  }

  function resolveZipFromIp() {
    try {
      var cached = localStorage.getItem("sms_rebate_zip") || localStorage.getItem("ch_rebate_zip") || "";
      if (/^\d{5}$/.test(cached)) return Promise.resolve(cached);
    } catch (error) {}

    function fetchJson(url, field) {
      if (!window.fetch) return Promise.resolve("");

      return fetch(url, { credentials: "omit" })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (data) {
          var zip = data && data[field] ? String(data[field]) : "";
          var match = zip.match(/\d{5}/);
          return match ? match[0] : "";
        })
        .catch(function () {
          return "";
        });
    }

    return fetchJson("https://ipapi.co/json/", "postal").then(function (zip) {
      if (zip) return zip;
      return fetchJson("https://ipwho.is/", "postal");
    }).then(function (zip) {
      if (/^\d{5}$/.test(zip)) {
        try {
          localStorage.setItem("sms_rebate_zip", zip);
          localStorage.setItem("ch_rebate_zip", zip);
        } catch (error) {}
      }
      return zip || "";
    });
  }

  function buildEntryForSku(sku, zip, details, fetchError) {
    var product = details.length && details[0].product ? details[0].product : {};
    var programs = [];
    var dedupe = {};
    var maxAmount = 0;

    details.forEach(function (detail) {
      if (detail.maxRebate && Number(detail.maxRebate.amount || 0) > maxAmount) {
        maxAmount = Number(detail.maxRebate.amount || 0);
      }

      (detail.rebatePrograms || []).forEach(function (program) {
        var key = [program.id || "", program.claimFormURL || "", program.amountLabel || "", program.name || ""].join("|");
        if (dedupe[key]) return;
        dedupe[key] = true;

        var amountValue = program.purchaseRebate && program.purchaseRebate.amount != null
          ? Number(program.purchaseRebate.amount)
          : (detail.maxRebate && detail.maxRebate.amount != null ? Number(detail.maxRebate.amount) : 0);
        if (amountValue > maxAmount) maxAmount = amountValue;

        programs.push({
          id: program.id || "",
          amountLabel: program.amountLabel || "",
          amountValue: amountValue,
          name: program.name || program.adminName || "Rebate Program",
          claimFormURL: program.claimFormURL || "",
          getFormLabel: program.getFormLabel || "Submit Online",
          validDates: Array.isArray(program.validDates) ? program.validDates : [],
          buyAfter: program.purchaseDates && program.purchaseDates.buyAfter ? program.purchaseDates.buyAfter : "",
          buyBefore: program.purchaseDates && program.purchaseDates.buyBefore ? program.purchaseDates.buyBefore : "",
          claimBy: program.purchaseDates && program.purchaseDates.claimBy ? program.purchaseDates.claimBy : "",
          claimWithin: program.purchaseDates && program.purchaseDates.claimWithin ? program.purchaseDates.claimWithin : "",
          importantDetails: Array.isArray(program.importantDetails) ? program.importantDetails : []
        });
      });
    });

    programs.sort(function (a, b) { return (b.amountValue || 0) - (a.amountValue || 0); });

    return {
      sku: sku,
      zip: zip,
      details: details,
      product: product,
      programs: programs,
      programCount: programs.length,
      maxAmount: maxAmount,
      error: fetchError || ""
    };
  }

  function fetchRebatesForSku(sku, zip, provider) {
    if (!provider) return Promise.resolve(buildEntryForSku(sku, zip, [], "Unsupported rebate provider."));

    var paramsObj = {
      c: "US",
      filter_rebate_consumer_type: "residential",
      retryZip: "true",
      uiContext: "PDP",
      zip: zip
    };
    var requestSku = provider.key === "aciq" || provider.key === "hvacdirect" ? String(sku || "").toLowerCase() : sku;

    paramsObj[provider.skuParam] = requestSku;
    Object.keys(provider.extraParams || {}).forEach(function (key) {
      paramsObj[key] = provider.extraParams[key];
    });

    return jsonpRequest(provider.baseUrl + "?" + new URLSearchParams(paramsObj).toString(), 18000)
      .then(function (payload) {
        var details = payload &&
          payload.EcoRebatesResponse &&
          Array.isArray(payload.EcoRebatesResponse.productRebateDetails)
          ? payload.EcoRebatesResponse.productRebateDetails
          : [];
        details = details.filter(function (detail) {
          return detailMatchesRequestedSku(detail, sku, provider);
        });
        return buildEntryForSku(sku, zip, details, "");
      })
      .catch(function (error) {
        return buildEntryForSku(sku, zip, [], error && error.message ? error.message : "Lookup failed.");
      });
  }

  function bindRebates(root) {
    var rebateWrap = root.querySelector("[data-sms-visual-rebate]");
    if (!rebateWrap) return;

    var rebateNote = root.querySelector("[id^='RebateNote-']");
    var rebateResults = root.querySelector("[id^='RebateResults-']");
    var rebateModal = root.querySelector("[id^='RebateModal-']");
    var rebateModalCloseTop = root.querySelector("[id^='RebateModalCloseTop-']");
    var rebateModalCloseBottom = root.querySelector("[id^='RebateModalCloseBottom-']");
    var rebateModalContent = root.querySelector("[id^='RebateModalContent-']");
    var rebateZipInput = root.querySelector("[id^='RebateZipInput-']");
    var rebateZipUpdate = root.querySelector("[id^='RebateZipUpdate-']");
    var context = getJson(root, "[data-sms-visual-product-context]") || {};
    var state = {
      provider: getRebateProvider(context),
      resultsBySku: {},
      queriedSkus: [],
      activeSku: "",
      zip: ""
    };

    if (!rebateResults || !rebateModal || !rebateModalContent || !rebateZipInput || !rebateZipUpdate) return;

    if (rebateModal.parentNode !== document.body) {
      document.body.appendChild(rebateModal);
    }

    function showNote(message) {
      if (!rebateNote) return;
      rebateNote.textContent = message || "";
      rebateNote.hidden = !message;
    }

    function clearResults() {
      var rebateSummary = root.querySelector("[id^='RebateSummary-']");
      if (rebateSummary) rebateSummary.textContent = "";
      rebateResults.innerHTML = "";
    }

    function closeModal() {
      rebateModal.hidden = true;
      document.body.style.overflow = "";
      state.activeSku = "";
    }

    function renderModalContent(sku) {
      var entry = state.resultsBySku[sku];
      if (!entry || !entry.programCount) {
        rebateModalContent.innerHTML = "<p>No rebate data loaded.</p>";
        return;
      }

      var product = entry.product || {};
      var imageHtml = product.imageUrl
        ? '<img src="' + escapeHtml(product.imageUrl) + '" alt="' + escapeHtml(product.shortName || sku) + '">'
        : "";
      var title = product.shortName || ("SKU " + sku);
      var info = product.infoLabel || "";
      var maxLabel = formatUSD(entry.maxAmount);
      var html = "";
      html += '<div class="rebate-product-head' + (imageHtml ? "" : " rebate-product-head--no-image") + '">';
      html += imageHtml;
      html += '<div><p class="rebate-product-name">' + escapeHtml(title) + '</p>';
      if (info) html += '<p class="rebate-product-meta">' + escapeHtml(info) + '</p>';
      html += '</div>';
      html += '<button type="button" class="rebate-summary-button" disabled>' +
        entry.programCount + ' rebate' + (entry.programCount === 1 ? '' : 's') + ' up to ' + maxLabel + '</button>';
      html += '</div>';

      html += '<div class="rebate-program-scroll">';
      entry.programs.forEach(function (program) {
        html += '<div class="rebate-program-row">';
        html += '<div class="rebate-program-amt">' + escapeHtml(program.amountLabel || formatUSD(program.amountValue)) + '</div>';
        html += '<div>';
        html += '<div><strong>' + escapeHtml(program.name) + '</strong></div>';
        if (program.validDates && program.validDates.length) {
          html += '<div class="product__rebate-note">' + escapeHtml(program.validDates.join(" | ")) + '</div>';
        }
        if (program.buyAfter || program.buyBefore || program.claimBy || program.claimWithin) {
          html += '<div class="product__rebate-note">';
          if (program.buyAfter) html += 'Buy on/after: ' + escapeHtml(program.buyAfter) + '<br>';
          if (program.buyBefore) html += 'Buy on/before: ' + escapeHtml(program.buyBefore) + '<br>';
          if (program.claimBy) html += 'Claim by: ' + escapeHtml(program.claimBy) + '<br>';
          if (program.claimWithin) html += 'Claim within: ' + escapeHtml(program.claimWithin);
          html += '</div>';
        }
        if (program.importantDetails && program.importantDetails.length) {
          html += '<details class="rebate-details"><summary>More details</summary><ul>';
          program.importantDetails.forEach(function (detail) {
            html += '<li>' + escapeHtml(detail) + '</li>';
          });
          html += '</ul></details>';
        }
        html += '</div><div>';
        if (program.claimFormURL) {
          html += '<a class="rebate-submit-btn" href="' + escapeHtml(program.claimFormURL) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(program.getFormLabel || "Submit Online") + '</a>';
        }
        html += '</div></div>';
      });
      html += '</div>';

      rebateModalContent.innerHTML = html;
    }

    function openModal(sku) {
      state.activeSku = sku;
      renderModalContent(sku);
      rebateModal.hidden = false;
      document.body.style.overflow = "hidden";
    }

    function renderSummaryCards() {
      clearResults();
      state.queriedSkus.forEach(function (sku) {
        var entry = state.resultsBySku[sku];
        if (!entry || entry.error || !entry.programCount) return;

        var card = document.createElement("div");
        var title = document.createElement("h4");
        var productNote = document.createElement("p");
        var button = document.createElement("button");

        card.className = "product__rebate-sku-card";
        title.className = "product__rebate-sku-title";
        title.textContent = sku;
        card.appendChild(title);

        if (entry.product && entry.product.shortName) {
          productNote.className = "product__rebate-note";
          productNote.textContent = entry.product.shortName;
          card.appendChild(productNote);
        }

        button.type = "button";
        button.className = "rebate-summary-button";
        button.textContent = entry.programCount + " rebate" + (entry.programCount === 1 ? "" : "s") + " up to " + formatUSD(entry.maxAmount);
        button.addEventListener("click", function () {
          openModal(sku);
        });
        card.appendChild(button);
        rebateResults.appendChild(card);
      });
    }

    function searchAllSkus(skus, zip) {
      if (!skus.length || !/^\d{5}$/.test(zip) || !state.provider) return Promise.resolve();

      state.zip = zip;
      rebateZipInput.value = zip;
      state.queriedSkus = skus.slice();
      showNote("");
      clearResults();

      return Promise.all(skus.map(function (sku) {
        return fetchRebatesForSku(sku, zip, state.provider);
      })).then(function (entries) {
        var hasAny = false;
        state.resultsBySku = {};

        entries.forEach(function (entry) {
          state.resultsBySku[entry.sku] = entry;
          if (entry && !entry.error && entry.programCount > 0) hasAny = true;
        });

        rebateWrap.hidden = !hasAny;
        if (!hasAny) {
          clearResults();
          closeModal();
          return;
        }

        renderSummaryCards();
        if (state.activeSku && state.resultsBySku[state.activeSku]) {
          renderModalContent(state.activeSku);
        }
      });
    }

    function loadRebatesForSkus(skus) {
      if (!state.provider || !skus.length) {
        rebateWrap.hidden = true;
        clearResults();
        return;
      }

      if (/^\d{5}$/.test(state.zip)) {
        searchAllSkus(skus, state.zip);
        return;
      }

      resolveZipFromIp().then(function (zip) {
        if (!/^\d{5}$/.test(zip)) {
          rebateWrap.hidden = true;
          clearResults();
          return;
        }
        searchAllSkus(skus, zip);
      });
    }

    function updateForSku(rawSku) {
      var skus = extractSkus(rawSku);
      if (!skus.length) {
        rebateWrap.hidden = true;
        clearResults();
        closeModal();
        return;
      }

      rebateWrap.setAttribute("data-sms-visual-rebate-sku", rawSku || "");
      loadRebatesForSkus(skus);
    }

    function handleZipUpdate() {
      var zip = String(rebateZipInput.value || "").replace(/\D/g, "").slice(0, 5);
      rebateZipInput.value = zip;
      if (!/^\d{5}$/.test(zip)) {
        showNote("Enter a valid 5-digit ZIP code.");
        return;
      }

      try {
        localStorage.setItem("sms_rebate_zip", zip);
        localStorage.setItem("ch_rebate_zip", zip);
      } catch (error) {}

      state.zip = zip;
      rebateZipUpdate.disabled = true;
      searchAllSkus(extractSkus(rebateWrap.getAttribute("data-sms-visual-rebate-sku") || ""), zip)
        .finally(function () {
          rebateZipUpdate.disabled = false;
        });
    }

    root.smsVisualUpdateRebates = updateForSku;

    rebateModalCloseTop && rebateModalCloseTop.addEventListener("click", closeModal);
    rebateModalCloseBottom && rebateModalCloseBottom.addEventListener("click", closeModal);
    rebateModal.addEventListener("click", function (event) {
      if (event.target === rebateModal) closeModal();
    });
    rebateZipUpdate.addEventListener("click", handleZipUpdate);
    rebateZipInput.addEventListener("input", function () {
      rebateZipInput.value = String(rebateZipInput.value || "").replace(/\D/g, "").slice(0, 5);
    });
    rebateZipInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        handleZipUpdate();
      }
    });
  }

  function openInfoAccordionFromHash(hash) {
    if (!hash || hash === "#") return;

    var id = hash.charAt(0) === "#" ? hash.slice(1) : hash;
    try {
      id = decodeURIComponent(id);
    } catch (error) {
      return;
    }

    var target = document.getElementById(id);
    if (target && target.matches && target.matches(".sms-visual-info-accordion")) {
      target.open = true;
    }
  }

  function bindInfoAccordions(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener("click", function () {
        openInfoAccordionFromHash(link.getAttribute("href"));
      });
    });

    if (window.location && window.location.hash) {
      window.setTimeout(function () {
        openInfoAccordionFromHash(window.location.hash);
      }, 0);
    }
  }

  function init(root) {
    if (!root || root.dataset.smsVisualPdpInit === "true") return;
    root.dataset.smsVisualPdpInit = "true";

    var variantPayload = getJson(root, "[data-sms-visual-variants]");
    var variants = Array.isArray(variantPayload)
      ? variantPayload
      : (variantPayload && Array.isArray(variantPayload.variants) ? variantPayload.variants : []);
    var idInput = root.querySelector("[data-sms-visual-variant-id]");
    var current = findVariantById(variants, idInput && idInput.value) || variants[0];
    root.smsVisualMetrics = getJson(root, "[data-sms-visual-metrics]") || {};
    root.smsVisualPricing = getJson(root, "[data-sms-visual-pricing]") || {};
    root.smsVisualBackorders = getJson(root, "[data-sms-visual-backorders]") || {};
    root.smsVisualVariants = variants;
    root.smsVisualSectionId = root.getAttribute("data-section-id") || "";

    root.querySelectorAll("[data-sms-visual-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        updateMedia(root, thumb.getAttribute("data-media-id"), thumb.getAttribute("data-image-id"));
      });
    });

    root.querySelectorAll("[data-sms-visual-option]").forEach(function (input) {
      input.addEventListener("change", function () {
        var options = buildOptionSet(root, root.smsVisualCurrentVariant || current);
        var nextVariant = findVariant(variants, options);
        current = updateVariant(root, nextVariant, variants) || current;
      });
    });

    if (root.dataset.smsVisualNativeBound !== "true") {
      root.dataset.smsVisualNativeBound = "true";
      var nativeSelectionFrame = null;

      function isNativePickerEvent(event) {
        var target = event && event.target;
        return Boolean(target && target.closest && target.closest("variant-selects") && root.contains(target));
      }

      function applyNativeSelection() {
        var nextVariant = findNativeVariant(root, variants, root.smsVisualCurrentVariant || current);
        current = updateVariant(root, nextVariant, variants) || current;
      }

      function scheduleNativeSelection() {
        if (nativeSelectionFrame !== null) return;

        var run = function () {
          nativeSelectionFrame = null;
          applyNativeSelection();
        };

        nativeSelectionFrame = window.requestAnimationFrame
          ? window.requestAnimationFrame(run)
          : window.setTimeout(run, 0);
      }

      function queueNativeSelection(event) {
        if (!isNativePickerEvent(event)) return;

        var immediateVariant = findNativeVariantFromEvent(root, variants, event, root.smsVisualCurrentVariant || current);
        if (
          immediateVariant &&
          (!root.smsVisualCurrentVariant || String(root.smsVisualCurrentVariant.id) !== String(immediateVariant.id))
        ) {
          current = updateVariant(root, immediateVariant, variants) || current;
        }

        scheduleNativeSelection();
      }

      root.addEventListener("click", queueNativeSelection, true);
      root.addEventListener("change", queueNativeSelection, true);
      root.addEventListener("input", queueNativeSelection, true);
    }

    function applyExternalVariant(variant, sectionId) {
      if (!variant || !variant.id) return;
      if (sectionId && root.smsVisualSectionId && String(sectionId) !== String(root.smsVisualSectionId)) return;
      if (root.smsVisualDispatchingVariant) return;

      current = updateVariant(root, findVariantById(variants, variant.id) || variant, variants) || current;
    }

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        var data = payload && payload.data ? payload.data : {};
        applyExternalVariant(data.variant, data.sectionId);
      });
    }

    document.addEventListener("variant:change", function (event) {
      var detail = event && event.detail ? event.detail : {};
      applyExternalVariant(detail.variant, detail.sectionId);
    });

    bindQuantity(root);
    bindForm(root);
    bindZoom(root);
    bindMoreMedia(root);
    bindAccessoryVisibility(root);
    bindWishlist(root);
    bindRebates(root);
    bindInfoAccordions(root);
    updateVariant(root, current, variants);

    setTimeout(function () {
      document.dispatchEvent(new CustomEvent("sms:techdata:open"));
    }, 0);

    setTimeout(function () {
      document.dispatchEvent(new CustomEvent("sms:techdata:open"));
    }, 500);
  }

  function boot(scope) {
    var rootScope = scope && scope.querySelectorAll ? scope : document;
    rootScope.querySelectorAll("[data-sms-visual-pdp]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
